/*
*
* Script for fixed navigation
*
*/

export const scrollFlag = () => {
    const nav = document.querySelector(".header");
    const header = document.querySelector("header");

    if (!nav || !header) return;

    if (window.pageYOffset > 142) {
        nav.classList.add("--scrolled");
        header.classList.add("--scrolled");
    } else {
        nav.classList.remove("--scrolled");
        header.classList.remove("--scrolled");
    }
}
